import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Colours from './styled/Colours';

const ThemeAlert = styled.div<{ variant: string }>`
  border-radius: 2px;
  color: ${Colours.secondaryText};
  margin-bottom: 1.25rem;
  padding: 1rem;

  p:last-child {
    margin-bottom: 0;
  }

  ${({ variant }) =>
    variant === 'error' &&
    `
  background: ${Colours.critical20};
  border: 1px solid ${Colours.critical};
  color: ${Colours.critical};
`}

  ${({ variant }) =>
    variant === 'warn' &&
    `
    background: ${Colours.neutral20};
    border: 1px solid ${Colours.neutral};
  `}

  ${({ variant }) =>
    variant === 'info' &&
    `
    background-color: #F0FAFF;
    border: 1px solid #8abef3;
  `}

  ${({ variant }) =>
    variant === 'note' &&
    `
    background-color: #f5f5f5;
    border: 1px solid ${Colours.lightGrey20};
  `}
`;

type Props = {
  variant: 'error' | 'warn' | 'info' | 'note';
  className?: string;
  children: ReactNode;
};

const Alert = ({ children, variant, className }: Props) => (
  <ThemeAlert variant={variant!} className={className}>
    {children}
  </ThemeAlert>
);
Alert.defaultProps = {
  className: undefined,
};

export default Alert;
